import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FileText, Clock } from "lucide-react";
import { api } from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";
import { DocDownloadButtons } from "@/components/DocDownloadButtons";

const fmt = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" }) +
    " " + d.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });
};

export default function RecentDocuments() {
  const navigate = useNavigate();
  const [docs, setDocs] = useState(null);

  useEffect(() => {
    api.recentDocuments(12).then(setDocs).catch(() => setDocs([]));
  }, []);

  if (!docs || docs.length === 0) return null;

  return (
    <section data-testid="recent-documents" className="mt-14">
      <div className="mb-4 flex items-end justify-between">
        <div>
          <div className="mb-2 inline-flex items-center gap-2 rounded-full border border-border bg-background px-3 py-1 text-xs font-medium text-muted-foreground">
            <Clock className="h-3.5 w-3.5" /> Son yüklenenler
          </div>
          <h2 className="text-base font-bold tracking-tight md:text-lg">Son yüklenen dokümanlar</h2>
          <p className="mt-1 text-sm text-muted-foreground">
            Orijinal dosyayı indirin ya da işlenmiş metni Markdown olarak dışa aktarın.
          </p>
        </div>
      </div>
      <div className="soft-card divide-y divide-border">
        {docs.map((doc) => (
          <div
            key={doc.id}
            data-testid={`recent-doc-${doc.id}`}
            className="flex flex-wrap items-center gap-3 px-4 py-3 sm:flex-nowrap sm:gap-4"
          >
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-secondary">
              <FileText className="h-4 w-4 text-muted-foreground" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="truncate text-sm font-medium">{doc.filename}</div>
              <div className="mt-0.5 flex flex-wrap items-center gap-x-2 text-xs text-muted-foreground">
                <button
                  data-testid={`recent-doc-dataset-${doc.id}`}
                  onClick={() => navigate(`/datasets/${doc.dataset_id}`)}
                  className="truncate underline-offset-2 transition-colors hover:text-foreground hover:underline"
                >
                  {doc.project_name} › {doc.dataset_name}
                </button>
                <span>·</span>
                <span className="mono">{fmt(doc.created_at)}</span>
                <span>·</span>
                <span>{doc.segment_count || 0} parça</span>
                {doc.original_available === false && (
                  <span className="rounded-full bg-amber-50 px-2 py-0.5 text-[11px] text-amber-700">orijinal yok · metin dışa aktarılabilir</span>
                )}
              </div>
            </div>
            <StatusBadge status={doc.status} testId={`recent-status-${doc.id}`} />
            <div className="flex items-center gap-1">
              <DocDownloadButtons doc={doc} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
